import { Earning_Mechanism_Typename } from '@occc/graphql';

import { EarningMechanismTypename } from './in-progress-offers.types';

export const OFFER_MAX_PUNCH_CARD_REQUIRED_PROGRESS = 10 as const;

export const headers = [
  { label: '' },
  { label: 'Name' },
  { label: 'Description' },
  { label: 'Progress' },
  { label: 'Total Req' },
  { label: '' },
];

export const earningMechanismWithProgressTypenames: EarningMechanismTypename[] = [
  Earning_Mechanism_Typename.EarningMechanismTotalSpendOverTime,
  Earning_Mechanism_Typename.EarningMechanismVarietyPurchaseOverTime,
  Earning_Mechanism_Typename.EarningMechanismVisits,
  Earning_Mechanism_Typename.EarningMechanismTotalEligiblePurchaseOverTime,
];
